import React, { useState } from 'react';
import { X, Mail } from 'lucide-react';
interface SendPaymentLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (includeMessage: boolean, message: string) => void;
  customerEmail: string;
}
export function SendPaymentLinkModal({
  isOpen,
  onClose,
  onSend,
  customerEmail
}: SendPaymentLinkModalProps) {
  const [includeMessage, setIncludeMessage] = useState(false);
  const [message, setMessage] = useState('');
  if (!isOpen) return null;
  const handleSend = () => {
    onSend(includeMessage, message);
    onClose();
    // Reset state
    setIncludeMessage(false);
    setMessage('');
  };
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-[rgba(15,23,42,0.5)] z-[1040]" onClick={onClose} data-id="element-3177" />

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-[1050] p-4" data-id="element-3178">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-[480px] animate-[ocean-scale-in_200ms_ease-in-out]" data-id="element-3179">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-[#E2E8F0]" data-id="element-3180">
            <div className="flex items-center gap-3" data-id="element-3181">
              <div className="w-10 h-10 rounded-full bg-[#E0F2FE] flex items-center justify-center" data-id="element-3182">
                <Mail className="w-5 h-5 text-[#0EA5E9]" data-id="element-3183" />
              </div>
              <h2 className="text-[20px] font-semibold text-[#0F172A]" data-id="element-3184">
                Send Payment Update Link
              </h2>
            </div>
            <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-md text-[#64748B] hover:bg-[#F1F5F9] hover:text-[#0F172A] transition-colors" data-id="element-3185">
              <X className="w-5 h-5" data-id="element-3186" />
            </button>
          </div>

          {/* Body */}
          <div className="px-6 py-6" data-id="element-3187">
            <p className="text-[14px] text-[#475569] mb-6" data-id="element-3188">
              Send a secure link to{' '}
              <span className="font-medium text-[#0F172A]" data-id="element-3189">
                {customerEmail}
              </span>{' '}
              to update their payment method?
            </p>

            {/* Include message checkbox */}
            <div className="space-y-4" data-id="element-3190">
              <div className="flex items-start gap-3" data-id="element-3191">
                <input type="checkbox" id="includeMessage" checked={includeMessage} onChange={e => setIncludeMessage(e.target.checked)} className="w-[18px] h-[18px] mt-0.5 text-[#0EA5E9] border-2 border-[#CBD5E1] rounded focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20" data-id="element-3192" />
                <label htmlFor="includeMessage" className="text-[14px] text-[#0F172A] font-medium cursor-pointer select-none" data-id="element-3193">
                  Include custom message
                </label>
              </div>

              {/* Message textarea */}
              {includeMessage && <div className="animate-[ocean-slide-up_200ms_ease-in-out]" data-id="element-3194">
                  <label className="block text-[12px] font-medium text-[#475569] mb-1.5" data-id="element-3195">
                    Custom Message
                  </label>
                  <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Add a personal note to the customer..." rows={4} className="w-full px-3 py-2.5 border border-[#CBD5E1] rounded-md bg-white text-[#0F172A] text-[14px] placeholder:text-[#94A3B8] focus:border-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 outline-none transition-[border-color,box-shadow] duration-200 ease-in-out resize-none" data-id="element-3196" />
                  <p className="text-[12px] text-[#64748B] mt-1.5" data-id="element-3197">
                    This message will be included in the email sent to the
                    customer.
                  </p>
                </div>}
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-[#E2E8F0]" data-id="element-3198">
            <button onClick={onClose} className="h-10 px-5 bg-white border border-[#CBD5E1] rounded-md text-[#0F172A] text-[14px] font-medium hover:bg-[#F1F5F9] hover:border-[#94A3B8] focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 transition-all" data-id="element-3199">
              Cancel
            </button>
            <button onClick={handleSend} className="h-10 px-5 bg-[#0EA5E9] border border-[#0EA5E9] rounded-md text-white text-[14px] font-medium hover:bg-[#0284C7] hover:border-[#0284C7] focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 transition-all" data-id="element-3200">
              Send Link
            </button>
          </div>
        </div>
      </div>
    </>;
}